import {Component, OnInit} from '@angular/core';
import {HiringService} from '../../../api/hiring/hiring.service';
import {Router} from '@angular/router';
import {Observable} from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import Sortable from 'sortablejs'
import { Title } from '@angular/platform-browser';

declare var $: any;
declare var jQuery: any;

@Component({
    selector: 'application-page',
    templateUrl: './hiring.html'
})

export class Hiring implements OnInit {
    hiring = [];
    i: number;
    id: string;
    TableData = [];
    name: string;
    subtitle: string;
    description: string;
    isactive: boolean;
    qualification: string;

    constructor(private hiringService: HiringService,
                private router: Router ,private titleService : Title) {
    }

    ngOnInit() {
        this.titleService.setTitle("Hiring  | Phoenix Games");
        if (localStorage.getItem('token') && localStorage.getItem('role') == 'SUPERADMIN') {
            $(function () {
                $('.summernote').summernote({
                    height: 350
                });
            });
            $(function () {
                $('.summernote2').summernote({
                    height: 350
                });
            });
            this.hiringService.allHiring()
                .then(data => {
                    this.hiring = data;

                });
            var el = document.getElementById('items');
            var sortable = new Sortable(el, {
                animation: 150,
                ghostClass: 'blue-background-class'
            });
        } else {
            this.router.navigate(['/']);
        }
    }

    cancelAction() {
        this.id = "";
        this.name = "";
        this.subtitle = "";
        this.description = "";
        this.isactive = false;
        this.qualification = "";
        $('div.note-editable').html("")
    }

    submitHiring() {
        if (this.name == undefined || this.name == undefined) {
            $.notify({
                message: "Please fillup all feilds"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'right'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        else {
            var descriptionhtml = $('div.note-editable').html();
           
            var appData = {
                name: this.name,
                subtitle: this.subtitle,
                description: descriptionhtml,
                isactive: this.isactive,
                sequenceindex: this.i,
                qualification : this.qualification
            };
            this.hiringService.iHiring(appData).then(data => {
                if (data.status) {
                    this.hiring.push(data.data);
                    this.cancelAction();
                    $.notify({
                        message: "Successfully inserted"
                    }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });
                } else {
                    this.cancelAction();
                }
            });
            $(function () {
                $('#addHiring').modal('toggle');
            });
        }
    }


    showHiring(hiring, i) {
       
        this.i = i;
        this.id = hiring.id;
        this.name = hiring.name;
        this.subtitle = hiring.subtitle;
        this.description = hiring.description;
        this.isactive = hiring.isactive;
        this.qualification = hiring.qualification;
        if (this.description != null) {
            $('div.note-editable').append(this.description);
        }
    }

    gettingsequence() {
        var TableData = new Array();

        $('#row-table tr').each(function (row, tr) {
            TableData[row] = {
                "id": $(tr).find('td:eq(0)').text(),
                "index": row - 1
            }

        });
        TableData.shift();
        this.TableData = TableData;
       
        var tbdata = {
            tabledata: this.TableData
        }
        this.hiringService.uHiringindex(tbdata).then(data => {
            if (data.status) {
                this.hiringService.allHiring()
                    .then(data => {

                        this.hiring = data;

                    });
                // this.cancelAction();
            } else {
                // this.cancelAction();
            }
        });

    }

    showDescription(hiring, i) {
        this.i = i;
        this.id = hiring._id;
        this.description = hiring.description;
    }

    deleteconfirmation(id, i) {
        //alert(JSON.stringify(keydata))
        this.i = i;
        this.id = id;
    }

    updateHiring() {

        if (this.name == undefined || this.name == undefined) {
            $.notify({
                message: "Please fillup all feilds"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'right'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        else {
            var descriptionhtml = $('.summernote2').siblings('.note-editor').children('.note-editing-area').children('div.note-editable').html();
          

            var appData = {
                name: this.name,
                subtitle: this.subtitle,
                description: descriptionhtml,
                isactive: this.isactive,
                qualification : this.qualification
            };
            this.hiringService.uHiring(this.id, appData).then(data => {
                if (data.status) {
                    this.hiring[this.i] = data.data;
                    this.cancelAction();
                    $.notify({
                        message: "Successfully Updated"
                    }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });
                    $(function () {
                        $('#updateHiring').modal('toggle');
                    });
                } else {
                    $.notify({
                        message: data.message
                    }, {
                        type: 'danger',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });
                }
            });
        }
    }

    deleteHiring() {

        this.hiringService.dHiring(this.id).then(data => {
            if (data.status) {
                this.hiring.splice(this.i, 1);
                $.notify({
                    message: "Successfully Deleted"
                }, {
                    type: 'success',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });
            } else {
                this.cancelAction();
            }
        });
    }
}





// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/structure/hiring/hiring.page.ts